module.exports = __webpack_public_path__ + "static/media/bq.10d31cc2.svg";